import {RootState} from '@/store'
import {ActionTree} from 'vuex'
import {RequestPayload, ServiceApi} from '@payroll/optimus-common'
import {EmployerDocumentState} from '@/store/modules/documents';
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";

export const actions: ActionTree<EmployerDocumentState, RootState> = {

    getDocuments: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
            .setRequestName('getDocuments')
            .setRequestBody(requestBody)
            .post(requestorCallback)
    },

    downloadDocument: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
            .setRequestName('downloadDocument')
            .setPathVariable(pathVariable)
            .get(requestorCallback)
    },

    deleteDocument: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
            .setRequestName('deleteDocument')
            .setPathVariable(pathVariable)
            .post(requestorCallback)
    },

    fetchDocumentTypes: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
        if (state.isEmpty) {
            new ServiceApi()
                .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
                .setRequestName('getDocumentTypes')
                .get(requestorCallback);
        } else {
            requestorCallback.onProgressFinished(true)
        }
    }
}